import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import { EmailInput, LoginPasswordInput } from './inputs';
import {
    LoginButton,
    ForgotPasswordButton,
    CreateAccountButton,
} from './buttons';
import OTCText from "@/common/customer/otc-text";
import ResendCode from "@/common/customer/buttons/resend-code";

const { UI, Customer } = Mobi2Go;

class SignInForm extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        email: PropTypes.string.isRequired,
        onEmailChange: PropTypes.func.isRequired,
        password: PropTypes.string.isRequired,
        onPasswordChange: PropTypes.func.isRequired,
        is_forgot_password_visible: PropTypes.bool.isRequired,
        onForgotPasswordClick: PropTypes.func.isRequired,
        onCreateAccountClick: PropTypes.func.isRequired,
        setSectionState: PropTypes.func.isRequired,
    };

    getPasswordInputContainerRef = () => this.password_input_container_ref;

    signIn = () => {
        const { email, password, t, setSectionState } = this.props;
        if (password.length === 0) {
            UI.alert({
                id: 'password-required',
                title: t('customer:login_enter_password_title'),
                body: t('customer:login_enter_password_body'),
                temp: true,
                primary_button: null,
                el: this.password_input_container_ref,
            });
        } else {
            setSectionState('', 'spinner');
            Customer.logIn(email, password);
        }
    };

    onPasswordInputKeyUp = e => e.key === 'Enter' && this.signIn();

    focusOnPasswordInput() {
        if (this.password_input_ref) {
            this.password_input_ref.focus();
        }
    }

    render() {
        const {
            email,
            onEmailChange,
            password,
            onPasswordChange,
            is_forgot_password_visible,
            onForgotPasswordClick,
            onCreateAccountClick,
            authentication_method
        } = this.props;

        const is_otc_sign_in = authentication_method?.otc_sign_in;

        return (
            <div>
                <EmailInput value={email} onChange={onEmailChange} />
                {is_otc_sign_in && <OTCText sent_to={email} />}
                <LoginPasswordInput
                    value={password}
                    onChange={onPasswordChange}
                    onKeyUp={this.onPasswordInputKeyUp}
                    ref={ref => {
                        this.password_input_ref = ref;
                    }}
                    containerRef={ref => {
                        this.password_input_container_ref = ref;
                    }}
                    authentication_method={authentication_method}
                />
                <LoginButton onClick={this.signIn} />
                {is_otc_sign_in && <ResendCode email={email} />}
                {is_forgot_password_visible && !is_otc_sign_in && (
                    <ForgotPasswordButton onClick={onForgotPasswordClick} />
                )}
                <CreateAccountButton onClick={onCreateAccountClick} />
            </div>
        );
    }
}

export default forwardRefWithTranslation('customer')(SignInForm);
